import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";
import { GetMFAStatusResData } from "./GetMFAStatusResData";

export class GetMFAStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + "/usermanagement";
    httpVerb: HttpVerbType = "get";

    constructor(username: string) {
        super();
        this.endPoint += `/${username}/mfa`;
    }

    public async execute(): Promise<GetMFAStatusResData> {
        var res = await this.executeCommand();
        return new GetMFAStatusResData(res);
    }
}
